module.exports = __webpack_public_path__ + "static/media/flag.8b1e8d63.svg";